'use strict';
import 'rxjs/add/observable/empty';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/takeUntil';
import {ViewMode} from '../../_libs/redux-observable-list';
import {getUserSubscriptions} from '../../comments/reducers';
import {onEnterView, onLeaveView} from '../../core-utilities/redux';
import {AbstractEpics} from '../../core-utilities/redux/AbstractEpics';
import {epicErrorHandler, eventToObservable} from '../../core-utilities/rx-utils';
import {userStates} from '../router-config';
import {logger} from './logger';


export class UserViewChannelsEpics extends AbstractEpics {

  constructor(options) {
    super(options);

    this.onEnter = this.onEnter.bind(this);

    this.onEnter.$inject = [
      '$rootScope',
      '$ngRedux',
      'userMetricsService',
    ];

    this.addEpics([
      this.onEnter,
    ]);
  }

  onEnter(action$, store, dependencies) {
    return onEnterView(action$, [userStates.chat])
      .switchMap(() => {
        const {
          $rootScope,
          $ngRedux,
          userMetricsService,
        } = dependencies;
        const {
          updateMethod,
          getter,
          event,
          timeout,
        } = userMetricsService.getLatestConversationProps();

        // HACK: We are watching state instead of actions inside of an epic.
        return $ngRedux.state$
          .map(getUserSubscriptions)
          .filter(state => state.mode === ViewMode.SUCCESS)
          .take(1)
          .switchMap(() =>
            eventToObservable($rootScope, event).startWith(getter())
              .delay(timeout)
              .throttleTime(1000, void 0, {leading: true, trailing: true})
              .switchMap(updateMethod)
              .catch(epicErrorHandler(logger, 'Failed to update user metrics'))
          )
          .takeUntil(onLeaveView(action$, [userStates.chat]));
      })
      // Does not output actions
      .filter(() => false)
      .catch(epicErrorHandler(this.logger, 'onLoginViewShowModal'));
  }
}

export const userViewChannelsEpics = new UserViewChannelsEpics({logger}).epics;



// WEBPACK FOOTER //
// ./src/js/user/redux/userViewChannelsEpics.js